import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import service from './service'
import workspace from './workspace'
import floating from './floating'
import loading from './loading'
import mtcount from './mtcount'
import clip from './clip'
import record from './record'
import comment from './comment'
import channel from './channel'
import transcript from './transcript'
import summary from './summary'
import websocket from './websocket'

import Toast from 'vue-toastification'
import { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
const options = {
  position: POSITION.TOP_CENTER,
  transition: 'fade',
  filterBeforeCreate: (toast, toasts) => {
    for (let i = 0; i < toasts.length; i++) {
      if (toast.content.props.msg === toasts[i].content.props.msg) {
        toasts[i].toastClassName = ['zoom-in-out-box']
        setTimeout(function () {
          toasts[i].toastClassName = null
        }, 300)
        return false
      }
    }
    return toast
  },
}

Vue.use(Vuex)

Vue.use(Toast, options)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    service,
    workspace,
    floating,
    loading,
    mtcount,
    clip,
    record,
    comment,
    channel,
    summary,
    transcript,
    websocket,
    alert,
  },
})
